import { CustomCellDate, CrudLink } from "@/shared/components";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import { Stack, Typography } from "@mui/material";
import type { MailerConfigRow } from "./types";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";

export const getColumnsConfig = (): ColumnDefinition<MailerConfigRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      customBodyRender: (data: unknown) => {
        const row = data as MailerConfigRow;
        return (
          <CrudLink id={row.id} tab="details">
            {row.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "from",
    label: "Отправитель (From)",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 180 } }),
    },
  },
  {
    name: "siteUrl",
    label: "URL сайта",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 160 } }),
    },
  },
  {
    name: "siteName",
    label: "Название сайта",
    options: {
      setCellHeaderProps: () => ({ style: { width: 140 } }),
    },
  },
  {
    name: "createdAt",
    label: "Создан",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Мейлеры",
  itemCreated: "Мейлер создан",
  itemUpdated: "Мейлер обновлён",
  createItem: "Создать мейлер",
  refetchList: "Обновить список",
  deleteItems: "Удалить",
  itemsDeleted: "Удалено",
  restoreItems: "Восстановить",
  itemsRestored: "Восстановлено",
  cancel: "Отмена",
  editItem: "Мейлер",
  showTitle: "Детали",
});

// Колонки для мобильного представления: название с отправителем и дата
export const getMobileColumnsConfig =
  (): DataListViewColumns<MailerConfigRow> => ({
    main: {
      title: "Конфигурация",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <Stack sx={{ minWidth: 0 }}>
          <CrudLink id={row.id} tab="details" noWrap>
            {row.title}
          </CrudLink>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.from ?? "—"}
          </Typography>
        </Stack>
      ),
    },
    createdAt: {
      title: "Создан",
      sx: { width: 96, flexShrink: 0 },
      renderCell: (row) => <CustomCellDate date={row.createdAt as string} />,
    },
  });
